module.exports = __webpack_public_path__ + "img/vidcents_wallet.0fe94ea7.svg";